import CalloutBox from './callout-box';

export default CalloutBox;
export { default as CalloutBoxAssembly } from './assembly';
